// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';
import { useDispatch } from 'react-redux';

import { useRevalidator } from 'react-router';

import { getCompanyById } from '../../../../store/companies/companiesActions';

import { PopOver } from '../../../UI/PopOver/PopOver';
import { CardLink } from '../../../UI/CardLink/CardLink';

import styles from '../Navigation.module.css';
import button from '../../../UI/Button/Button.module.css';

export const CompanyNavigation = ({ companies, company }) => {
  const dispatch = useDispatch();
  const revalidator = useRevalidator();

  const handleClick = async (companyUuid, setIsOpen) => {
    // Fetch the company by ID
    await dispatch(getCompanyById(companyUuid));
    // Revalidate root useLoader
    await revalidator.revalidate();
    if (setIsOpen) {
      setIsOpen(false); // Close popover after selection
    }
  };

  return (
    <PopOver
      color=''
      classname={button.btnNavigation}
      hoverEffect={true}
      buttonText={company?.company_uuid ? company?.company_name : 'Select company'}
    >
      {({ setIsOpen }) => (
        <div className={styles.navItemContainer}>
          {companies.map(company => (
            <CardLink
              key={company.company_uuid}
              view={false}
              grid={false}
              onClick={() => handleClick(company.company_uuid, setIsOpen)}
            >
              <p>{company.company_name}</p>
            </CardLink>
          ))}
        </div>
      )}
    </PopOver>
  );
};
